@if(isLoading){
<app-overlay-loading-spinner></app-overlay-loading-spinner>
}
<div class="attachment-files">
  <div class="my-3 d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center gap-2">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_598_6504)">
          <path
            d="M14.5018 2.29569C12.5077 0.301502 9.26289 0.301502 7.26845 2.29569L1.0682 8.49591C-0.356145 9.92041 -0.356051 12.2382 1.06839 13.6626C1.78067 14.3749 2.71598 14.731 3.65167 14.7309C4.58711 14.7308 5.52292 14.3748 6.23508 13.6626L11.9185 7.97906C12.3325 7.56506 12.5606 7.0146 12.5606 6.4291C12.5606 5.84356 12.3327 5.29313 11.9185 4.879C11.0638 4.02435 9.67305 4.02438 8.81848 4.87916L5.10176 8.59578C4.81642 8.88109 4.81642 9.34375 5.1017 9.62913C5.38701 9.91453 5.84967 9.91444 6.13504 9.62913L9.8518 5.91247C10.1367 5.62756 10.6002 5.6275 10.8851 5.91241C10.9532 5.9801 11.0072 6.06061 11.0439 6.1493C11.0806 6.23798 11.0994 6.33307 11.0992 6.42906C11.0992 6.62422 11.0232 6.80766 10.8851 6.94572L5.20173 12.6292C4.34701 13.4838 2.95639 13.484 2.10173 12.6293C1.24707 11.7746 1.24701 10.3839 2.10157 9.52916L8.3018 3.32903C9.72636 1.90453 12.0441 1.90453 13.4685 3.32903C14.1586 4.01903 14.5386 4.9365 14.5386 5.91235C14.5386 6.88819 14.1585 7.80566 13.4685 8.49572L7.26836 14.696C6.98304 14.9814 6.98304 15.444 7.26842 15.7294C7.33619 15.7973 7.41672 15.8512 7.50539 15.8879C7.59405 15.9247 7.68911 15.9435 7.78508 15.9434C7.88105 15.9435 7.9761 15.9246 8.06477 15.8879C8.15344 15.8512 8.23398 15.7973 8.30176 15.7294L14.5018 9.52909C15.4679 8.56306 16 7.27863 16 5.91238C16 4.54616 15.4679 3.26172 14.5018 2.29569Z"
            fill="#A3A3A3" />
        </g>
        <defs>
          <clipPath id="clip0_598_6504">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <span class="text-muted">{{formatFileSize(calculateTotalSize())}} ({{attachments.length}})</span>
    </div>
    <!-- <button pButton label="Download all" icon="pi pi-download" [text]="true" (click)="downloadAllFiles()"></button> -->
  </div>
  <div class="list-group">
    @for (file of attachments; track $index) {
    <div class="list-group-item d-flex align-items-center">
      <div class="file-icon me-3">
        <!-- File Icon Logic Based on File Type -->
        @if (file?.name?.includes('pdf') || file?.name?.endsWith('.pdf')) {
        <img class="fit-object-cover" src="assets/images/icons/pdficon.svg" alt="PDF Icon" />
        }
        @else if (file?.name?.includes('doc') ||
        file?.name === 'application/msword' || file?.name?.includes('.doc')) {
        <!-- Word Document Icon -->
        <img class="fit-object-cover" src="assets/images/icons/attachment-file.svg" alt="Word Icon" />
        }
        @else if (file?.name?.includes('excel') || file?.name === 'application/vnd.ms-excel' ||
        file?.name === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        file?.name?.includes('.xls') || file?.name?.includes('.xlsx')) {
        <!-- Excel File Icon -->
        <img class="fit-object-cover" src="assets/images/icons/attachment-xlsx.svg" alt="Excel Icon" />
        }
        @else if (file?.name?.includes('image')) {
        <!-- Image Preview -->
        <img class="fit-object-cover" src="assets/images/icons/attachment-image.svg" alt="File Icon" />
        }
        @else {
        <!-- Default File Icon -->
        <img class="fit-object-cover" src="assets/images/icons/attachments.svg" alt="File Icon" />
        }
      </div>
      <div class="file-details">
        <p>{{ file.name }}</p>
        <span>{{ formatFileSize(file.size) }}</span>
      </div>
      @if (hasReadAttachmentsPermission) {
      <div class="download-icon ms-auto">
        <button pButton label="" icon="pi pi-download" [text]="true" (click)="onDownload(file)"></button>
      </div>
      }
    </div>
    }
  </div>
</div>